// extracted by mini-css-extract-plugin
module.exports = {"container":"gI","links":"hI"};